export const money = (v) =>
  "€" + Number(v || 0).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const num = (v) => Number(v || 0).toLocaleString("en-IE");

export const TZ = "Europe/Dublin";
const parts = (d, opts) => Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hourCycle: "h23", ...opts }).formatToParts(d).map((p) => [p.type, p.value]));
const ieYMD = (d) => { const p = parts(d, { year: "numeric", month: "2-digit", day: "2-digit" }); return `${p.year}-${p.month}-${p.day}`; };
const ieHM = (d) => { const p = parts(d, { hour: "2-digit", minute: "2-digit" }); return `${p.hour}:${p.minute}`; };
export const todayIE = () => ieYMD(new Date());
export const ieDate = (iso) => ieYMD(new Date(iso));
export const toIELocal = (iso) => { if (!iso) return ""; const d = new Date(iso); return isNaN(d) ? "" : `${ieYMD(d)}T${ieHM(d)}`; };
export const fromIELocal = (local) => {
  const [dt, tm] = local.split("T"); const [y, m, d] = dt.split("-").map(Number); const [h, mi] = (tm || "00:00").split(":").map(Number);
  const guess = Date.UTC(y, m - 1, d, h, mi);
  const wall = new Date(toIELocal(new Date(guess).toISOString()) + ":00Z").getTime();
  return new Date(guess - (wall - guess)).toISOString();
};

export const date = (iso) => {
  if (!iso) return "—";
  if (iso.length <= 10) { const [y, m, d] = iso.split("-"); return d ? `${d}/${m}/${y}` : "—"; }
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const [y, m, dd] = ieYMD(d).split("-");
  return `${dd}/${m}/${y}`;
};

export const datetime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return `${date(iso)} ${ieHM(d)}`;
};

export const time = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? "—" : ieHM(d);
};

export const hhmm = (mins) => {
  const m = Math.round(mins || 0);
  return `${Math.floor(m / 60)}h ${m % 60}m`;
};

export const COST_ROLES = ["office", "supervisor", "management", "support"];
export const canSeeCost = (role) => COST_ROLES.includes(role);
export const isAdmin = (role) => ["management", "support", "office"].includes(role);
export const isSuper = (role) => role === "management";
export const canEdit = (role) => ["management", "support", "office", "supervisor"].includes(role);

export const ROLE_LABELS = {
  shop_floor: "Shop Floor",
  supervisor: "Supervisor",
  office: "Office Manager",
  management: "Super User",
  support: "Super User",
};

export const STAGE_META = {
  awaiting_work: { label: "Awaiting Work", cls: "bg-slate-700 text-slate-200 border-slate-600" },
  in_progress: { label: "In Progress", cls: "bg-sky-500/20 text-sky-300 border-sky-500/40" },
  blocked: { label: "Blocked / Hold", cls: "bg-red-500/20 text-red-300 border-red-500/50" },
  ready_for_inspection: { label: "Ready for Inspection", cls: "bg-amber-500/20 text-amber-300 border-amber-500/40" },
  ready_for_delivery: { label: "Ready for Delivery", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40" },
  completed: { label: "Completed", cls: "bg-slate-800 text-slate-400 border-slate-700" },
};

export const marginClass = (pct) =>
  pct >= 25 ? "text-emerald-400" : pct >= 10 ? "text-amber-400" : "text-red-400";
